export const iconFontAwesomeEditingTrashCan = (
	<i className="fa-solid fa-trash-can"></i>
);
